<template>
  <sweet-modal modal-theme="dark" overlay-theme="dark" ref="modal-edit-parcel">
     <h3>HAWB: {{ modals.header }}</h3>
    <el-form ref="form-edit" :model="form" label-width="140px">
     Status:
      <select :value="modals.content.status" placeholder="please select status" name="status" v-validate="'required'" ref="status">
        <option value="Ready">Ready</option>
        <option value="Hold">Hold</option>
        <option value="Released">Released</option>
        <option value="Over">Over</option>
        <option value="No Show">No Show</option>
        <option value="Unmanifest">Unmanifest</option>
        <option value="CAT4">CAT4</option>
      </select>
      <br>
      <br>
      <br>
      <!-- <el-form-item> -->
        <el-button type="warning" @click="onSubmit">Update</el-button>
      <!-- </el-form-item> -->
    </el-form>
  </sweet-modal>
</template>

<script>
import * as _apiParcel from "@/api/parcel"

export default {
  props: {
    modals: {
      notice: false,
      header: '',
      content: {},
    }
  },
  data: () => ({
    form: {
      status: '',
    }
  }),
  watch: {
    'modals.notice': function(newVal, oldVal){
      if (newVal) {
        this.$refs['modal-edit-parcel'].open()
        this.$emit('afterModalShow')
      }
    }
  },
  methods: {
    onSubmit () {
      _apiParcel.updateStatus(this.modals.content.id, {
          status: this.$refs.status.value,
        })
        .then(response => {
          if (response.data.success) {
            this.$notify({
              message: 'Updated',
              type: 'success'
            })
          } else {
            this.$notify({
              message: 'Update failed',
              type: 'danger'
            })
          }
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
            type: 'danger'
          })
        })
        .finally(() => {
          this.$refs['modal-edit-parcel'].close()
          this.$emit('afterUpdated')
        })
    }
  }
}
</script>

<style scoped lang="scss">
h3 {
  text-decoration: underline;
}
</style>
